module.exports = __webpack_public_path__ + "static/img/bigLab.0b60224c.png";